export default {
  annualFestival:{
      activityRemark:'活动备注',
      activityTemp:'模板',
    activityId:'活动id',

    page11_4: "128进32",
    page11_5: "32进16",
    page11_6: "16进8",
    page11_7: "8进4",
    page11_8: "4进2",
    page11_9: "2进1",
    page11_10: "64进32",

    temptext1:'N进1',
    temptext2:'1v1',
    temptext3:'16对阵图',

    formText1:'投票开始时间',
    formText2:'投票结束时间',
    contestant:'参赛选手',

    btnText1:'查看名单',
    btnText2:'修改ID',

    confirmList:'确认名单',

    clearMember:'确定清除名单吗？',
  }
}



// WEBPACK FOOTER //
// ./src/language/annualFestival-zh-cn.js